import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";

//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  addPoSelectedDetails,
  addSelectedItemList,
  addSubTransactionActivity,
  getPurchaseOrder,
  getSchedulingAgreement,
  getServicePO,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import { InputField } from "../../../../Components/formElements/InputField";

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";
import CustomerV2ItemService from "../../../../services/customer_v2_appCommonService";
import { currencyFormat, formatDate } from "../../../../common/Validations";
// import WorkflowApproveReject from "../../../../Components/Workflow/WorkflowApproveReject";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import PrintPO from "./PrintPO";
import { useReactToPrint } from "react-to-print";

const PurchaseOrderDetailedPage = () => {
  const dispatch = useDispatch();
  const divRef = useRef(null);
   localStorage.setItem("menu", "Project");
  localStorage.setItem("submenu", "Purchase Order");

  let getConstantVar = useSelector((state) => state?.common?.data); // User getConstantVar from Store
  let userInfo = useSelector((state) => state?.user?.data); // User Details from Store

  let poNumber = useSelector(
    (state) => state?.customer?.purchaseOrder?.purchaseOrderNr
  ); // purchase_order from Store
  let purchase_order_data = useSelector(
    (state) => state?.purchasing?.purchase_order?.data
  ); // purchase_order_data Details from Store

  let workflow = useSelector(
    (state) => state?.customer?.purchaseOrder?.workflowPO
  ); // workflowPO from Store

  let config = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.poDetailsPage
  ); // config Details from Store

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [getHeaderData, setHeaderData] = useState(false);

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [getViewHeaderText, setViewHeaderText] = useState(false);

  const [disabled, setDisabled] = useState(false);

  // eslint-disable-next-line
  const [getSelectedData, setSelectedData] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const [, /*getGrnHistoricalData*/ setGrnHistoricalData] = useState([]);
  const [, /*getAsnHistoricalData*/ setAsnHistoricalData] = useState([]);
  const [, /*getInvoiceHistoricalData*/ setInvoiceHistoricalData] = useState(
    []
  );
  const [, /*getSesHistoricalData*/ setSesHistoricalData] = useState([]);



  //Service Items
  let serviceColInfo = [
    {
      name: "Service Line Nr",
      cell: (row) => <span>{row.serviceLineNr} </span>,
      width: "180px",
    },
    {
      name: "Service Number",
      cell: (row) => <span>{row.serviceNr} </span>,
      width: "180px",
    },
    {
      name: "Service Desc",
      cell: (row) => <span>{row.serviceDescription} </span>,
      width: "180px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "180px",
    },
    {
      name: "Service Quantity",
      cell: (row) => <span>{row.serviceQuantity} </span>,
      width: "180px",
    },
    {
      name: "Unit Value",
      cell: (row) => <span>{row.unitValue} </span>,
      width: "180px",
    },
    {
      name: "Gross Value",
      cell: (row) => <span>{row.grossValue} </span>,
      width: "180px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "180px",
    },
  ];
  //ScheduleItems
  let scheduleColInfo = [
    {
      name: "Schedule LineNr",
      cell: (row) => <span>{row.scheduleLineNr} </span>,
      width: "180px",
    },
    {
      name: "Day/Week/Month",
      cell: (row) => <span>{row.schedulePeriod} </span>,
      width: "180px",
    },
    {
      name: "Schedule From",
      cell: (row) => <span>{row.scheduleFromDate} </span>,
      width: "180px",
    },
    {
      name: "Schedule To",
      cell: (row) => <span>{row.scheduleToDate} </span>,
      width: "180px",
    },
    {
      name: "Schedule Quantity",
      cell: (row) => <span>{row.scheduleQuantity} </span>,
      width: "180px",
    },
    {
      name: " Reservation No",
      cell: (row) => <span>{row.reservationNr} </span>,
      width: "180px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "180px",
    },
  ];
  const [getItemNr, setItemNr] = useState("");
  const [getServiceData, setServiceData] = useState([]);
  const [getServiceTableStatus, setServiceTableStatus] = useState(false);

  useEffect(() => {
    if (divRef.current) {
      try {
        // eslint-disable-next-line no-unused-vars
        const styles = window.getComputedStyle(divRef.current);
      } catch (error) {
        console.error("Failed to get computed style:", error);
      }
    }
  }, [getServiceTableStatus]);

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  // OnClick on Header Text  Data
  const headerTextShowModal = (headerTextData) => {
    setItemLevelData(headerTextData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Header Text Details");
    setViewHeaderText(true);
  };
  const headerTextHideModal = () => {
    setViewHeaderText(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  const loadInitialPageData = async () => {
    setLoading(true);
    if (poNumber) {
      let obj = {
        documentNumber: poNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await CustomerV2ItemService.getPODetail(obj).then((item) => {
        // console.log(">> Details res!", item);
        if (item?.status === 200) {
          setHeaderData(item?.data[0]);
          setData(item?.data[0]?.items);
          dispatch(addPoSelectedDetails(item?.data));
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });

      setLoading(false);
    } else {
      window.history.back();
    }
  };

  useEffect(() => {
    loadInitialPageData(); // fetch page 1 of users
    loadGrnHistoricalData(); // Load GRN History Data
    loadAsnHistoricalData(); // Load ASN History Data
    loadInvoiceHistoricalData(); // Load Invoice History Data
    loadSesHistoricalData(); // Load SES History Data
    dispatch(addSelectedItemList([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poNumber, purchase_order_data]);

  // PO columns Details
  const columns = [
    {
      name: "PO Item Nr",
      selector: (row) => row.indentDocumentItemNr,
      sortable: true,
      width: "140px",
    },

    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    /* {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
      width: "100px",
    }, */
    {
      name: "Purchase Quantity",
      selector: (row) => row.indentQuantity,
      sortable: true,
      width: "180px",
    },
    {
      name: "Order Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.quotationUnitPrice,
      sortable: true,
      width: "120px",
    },
    {
      name: "Item Value",
      selector: (row) => row?.qtnitemValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0  fw-bold">
          {currencyFormat(Number(row?.qtnitemValue).toFixed(2))}
        </span>
      ),

      sortable: true,
      width: "140px",
    },
    {
      name: "Tax %",
      selector: (row) => row.taxCode,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row?.taxAmount,
      sortable: true,
      width: "140px",
    },
    {
      name: "Gross Value",
      selector: (row) => row?.grossValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0  fw-bold">
          {currencyFormat(Number(row?.grossValue).toFixed(2))}
          {/* {row.grossValue} */}
        </span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Currency",
      selector: (row) => getHeaderData?.currency,
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Date",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 ">{formatDate(row?.deliveryDate)} </p>
        </div>
      ),
      width: "160px",
    },



  ];

  const columnsService = [
    {
      name: "PO Number",
      selector: (row) => poNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.statusItem} />
        </>
      ),
      width: "160px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "Service",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServiceItemTable(row.services, row.purchasingDocumentItemNr)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Purchase Quantity",
      selector: (row) => row.purchaseQuantity,
      sortable: true,
      width: "180px",
    },
    {
      name: "Order Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit,
      sortable: true,
      width: "120px",
    },
    {
      name: "Item Value",
      // selector: (row) => row.netValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.netValue).toFixed(2))}
        </span>
      ),

      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currency,
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      sortable: true,
      width: "200px",
    },

    {
      name: "Tax Code",
      selector: (row) => row.taxId,
      sortable: true,
      width: "200px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: true,
      width: "200px",
    },
    {
      name: "Free Of Cost",
      selector: (row) => row.freeCost,
      sortable: true,
      width: "200px",
    },
    {
      name: "Purch Req Nr",
      selector: (row) => row.requestNumber,
      sortable: true,
      width: "200px",
    },
    {
      name: "PR Item Nr",
      selector: (row) => row.prItemNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "ExcessTolerance",
      selector: (row) => row.excessTolerance,
      sortable: true,
      width: "200px",
    },
    {
      name: "ShortageTolerance",
      selector: (row) => row.shortageTolerance,
      sortable: true,
      width: "200px",
    },
  ];

  const columnsSchedule = [
    {
      name: "PO Number",
      selector: (row) => poNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.statusItem} />
        </>
      ),
      width: "160px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "Schedules",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServiceItemTable(row.schedule, row.purchasingDocumentItemNr)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.schedule?.length || 0} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Purchase Quantity",
      selector: (row) => row.purchaseQuantity,
      sortable: true,
      width: "180px",
    },
    {
      name: "Oder Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit,
      sortable: true,
      width: "120px",
    },
    {
      name: "Item Value",
      // selector: (row) => row.netValue,
      cell: (row) => (
        <span className="numberFormate">
          {currencyFormat(Number(row.netValue).toFixed(2))}
        </span>
      ),

      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currency,
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      sortable: true,
      width: "200px",
    },
    {
      name: "Tax Code",
      selector: (row) => row.taxId,
      sortable: true,
      width: "200px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: true,
      width: "200px",
    },
    {
      name: "Free Of Cost",
      selector: (row) => row.freeCost,
      sortable: true,
      width: "200px",
    },
    {
      name: "Purch Req Nr",
      selector: (row) => row.requestNumber,
      sortable: true,
      width: "200px",
    },
    {
      name: "PR Item Nr",
      selector: (row) => row.prItemNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "ExcessTolerance",
      selector: (row) => row.excessTolerance,
      sortable: true,
      width: "200px",
    },
    {
      name: "ShortageTolerance",
      selector: (row) => row.shortageTolerance,
      sortable: true,
      width: "200px",
    },
  ];

  // PO items columns Details
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  // Onclick on Table Header Button
  const handleAcknowledgeClick = async () => {
    let obj = {
      _id: getHeaderData?._id,
      purchasingDocumentNr: getHeaderData?.purchasingDocumentNr,
    };

    // if (getSelectedData.length > 0) {
    await ItemService.AcknowledgePO(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "PO Acknowledged successfully", {
          duration: 3000,
          position: "top-right",
        });

        setDisabled(true);
        setToggleCleared(true);
        setSelectedData([]);

        let materialPO = {
          queryName: "getMaterialPO",
          module: "PO",
        };
        let servicePO = {
          queryName: "getServicePO",
          module: "PO",
        };
        let schedulingAgreement = {
          queryName: "getSchedulingAgreement",
          module: "PO",
        };

        if (getHeaderData.purchaseTypeCode === "MAT") {
          dispatch(getPurchaseOrder(materialPO));
        } else if (getHeaderData.purchaseTypeCode === "SER") {
          dispatch(getServicePO(servicePO));
        } else if (getHeaderData.purchaseTypeCode === "SA") {
          dispatch(getSchedulingAgreement(schedulingAgreement));
        }
      } else {
        console.log("PO Acknowledged Not successfully");

        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  // Load GRN Historical data on page load
  const loadGrnHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOGrn(obj).then((item) => {
      // console.log(">> res! getPOGrn", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setGrnHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  // Load ASN Historical data on page load
  const loadAsnHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOAsn(obj).then((item) => {
      // console.log(">> res! getPOAsn", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setAsnHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  // Load Invoice Historical data on page load
  const loadInvoiceHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOInvoice(obj).then((item) => {
      // console.log(">> res! getPOInvoice", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setInvoiceHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  // Load Ses Historical data on page load
  const loadSesHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOSes(obj).then((item) => {
      // console.log(">> res! getPOSes", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setSesHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  //Selected from the Table
  const handleChange = ({ selectedRows }) => {
    setToggleCleared(false);
    setSelectedData(selectedRows);
    dispatch(addSelectedItemList(selectedRows));
    // if (selectedRows.length > 0) {
    //   setDisabled(false);
    // } else {
    //   setDisabled(true);
    // }
  };

  //Create ASN
  const createASN = () => { };

  //Create SA ASN
  const createSAASN = () => { };

  //Create GRN
  const createGRN = () => {
    let obj = {
      asnNumber: "",
      subTransactionActivity: "PO",
    };
    dispatch(addSubTransactionActivity(obj));
  };

  const totalTaxAmount = data?.reduce((sum, item) => sum + (item.taxAmount || 0), 0);
  const totalGrossValue = data?.reduce((sum, item) => sum + (item.grossValue || 0), 0);
  const totalQtnItemValue = data?.reduce((sum, item) => sum + (item.qtnitemValue || 0), 0);




  //Create SES
  const createSES = () => {
    let obj = {
      asnNumber: "",
      subTransactionActivity: "PO",
    };
    dispatch(addSubTransactionActivity(obj));
    // navigate(Constants.POCOLLABRATION_SES_CREATION);
  };

  //Create Invoice
  const createInvoice = () => {
    // navigate(Constants.POCOLLABRATION_INVOICE_CREATION);
  };

  //Create Invoice SES
  const createInvoiceSES = () => {
    // navigate(Constants.POCOLLABRATION_INVOICE_CREATION_SES);
  };
  // send print data
  const [printInvoiceData, setPrintInvoiceData] = useState();

  //print
  useEffect(() => {
    setPrintInvoiceData(getHeaderData);
  }, [getHeaderData]);

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `Purchase_Order_${Math.floor(Math.random() * 1000000)}`,
  });

  useEffect(() => {
    if (
      workflow?.workflow_record?.businessComponentId ===
      getConstantVar?.POBusinessComponentId
    ) {
      localStorage.setItem("menu", workflow?.page);
      localStorage.setItem("submenu", "-");
    } else {
      //console.log(">> getHeaderData", getHeaderData);
      if (getHeaderData.purchaseTypeCode === "MAT") {
        localStorage.setItem("menu", "Purchasing");
        localStorage.setItem("submenu", "Purchase Order");
      } else if (getHeaderData.purchaseTypeCode === "SER") {
        localStorage.setItem("menu", "Purchasing");
        localStorage.setItem("submenu", "Service PO");
      } else if (getHeaderData.purchaseTypeCode === "SA") {
        localStorage.setItem("menu", "Purchasing");
        localStorage.setItem("submenu", "Scheduling Agreement");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showServiceItemTable = (serviceData, itemNr) => {
    setItemNr(itemNr);
    setServiceData(serviceData);
    setServiceTableStatus(true);
  };
  const hide = () => {
    setServiceTableStatus(false);
  };
const goBack = () =>{
  window.history.back();
}
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Purchase Order Details :{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {poNumber}
              </span>
              <span>
                {getHeaderData?.statusHeader === "New" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "In Release" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "Acknowledged" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.rfxHeaderStatus === "PO Created" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.rfxHeaderStatus}
                  </span>
                ) : (
                  getHeaderData?.statusHeader
                )}
              </span>
            </h2>
            <p className="subText">Purchase Order Information </p>
            <hr />
            <Row>
<Col
              xs={2}
              md={2}
              lg={2}
              className="text-left mb-4"
              
            >
                 <button className="btnBack" onClick={() => goBack()}>
            <i className="bi bi-arrow-return-left"></i> Go Back
          </button>
            </Col>
            <Col
              xs={{ span: 2, offset: 2 }}
              md={{ span: 2, offset: 8 }}
              lg={{ span: 2, offset: 8 }}
              className="text-left mb-4"
              // onClick={createPo}
              onClick={handlePrint}
            >
              <button className="btnInfo">Print</button>
            </Col>
            </Row>
             <div style={{ display: "none" }}>
              <PrintPO ref={contentRef} data={printInvoiceData} />
            </div>

            {/* Workflow Component */}
            {/* <WorkflowApproveReject workflowData={workflow} /> */}

            {/* Header Details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                 
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">HD</span>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                      <span className="headerTitle">Header Details</span>
                      <span className="subHeaderTitle"> </span>
                    </Col>

                    {!workflow?.workflow_record?.businessComponentId &&
                      userInfo?.roles?.length > 0 &&
                      (userInfo?.roles[0].roleId === "VENDOR"
                        ? true
                        : false) && (
                        <>
                          {getHeaderData?.statusHeader === "Acknowledged" && (
                            <Col
                              xs={12}
                              md={8}
                              lg={8}
                              className="headerButtonAlign"
                            >
                              {config.createASN &&
                                getHeaderData.purchaseTypeCode === "SA" && (
                                  <Col xs={4} md={2} lg={2} className="">
                                    <button
                                      className="btnTable"
                                      onClick={() => createSAASN()}
                                    >
                                      <i className="bi bi-calendar-check"></i>{" "}
                                      Create ASN
                                    </button>
                                  </Col>
                                )}

                              {config.createGRN &&
                                getHeaderData.purchaseTypeCode === "MAT" && (
                                  <>
                                    {getHeaderData.process === "ASN" && (
                                      <Col xs={4} md={2} lg={2} className="">
                                        <button
                                          className="btnTable"
                                          onClick={() => createASN()}
                                        >
                                          <i className="bi bi-calendar-check"></i>{" "}
                                          Create ASN
                                        </button>
                                      </Col>
                                    )}

                                    {getHeaderData.process === "GRN" && (
                                      <Col xs={4} md={2} lg={2} className="">
                                        <button
                                          className="btnTable"
                                          onClick={() => createGRN()}
                                        >
                                          <i className="bi bi-truck"></i> Create
                                          Goods Receipt
                                        </button>
                                      </Col>
                                    )}
                                  </>
                                )}

                              {config.createSES &&
                                getHeaderData.purchaseTypeCode === "SER" && (
                                  <Col xs={4} md={2} lg={2} className="">
                                    <button
                                      className="btnTable"
                                      onClick={() => createSES()}
                                    >
                                      <i className="bi bi-file-spreadsheet"></i>{" "}
                                      Create SES
                                    </button>
                                  </Col>
                                )}

                              {config.createInvoice &&
                                getHeaderData.purchaseTypeCode === "MAT" && (
                                  <>
                                    {getHeaderData.process === "GRN" && (
                                      <Col xs={4} md={2} lg={2} className="">
                                        <button
                                          className="btnTable"
                                          onClick={() => createInvoice()}
                                        >
                                          <i className="bi bi-currency-dollar"></i>{" "}
                                          Create Invoice
                                        </button>
                                      </Col>
                                    )}
                                  </>
                                )}

                              {getHeaderData.purchaseTypeCode === "SER" && (
                                <Col xs={4} md={2} lg={2} className="">
                                  <button
                                    className="btnTable"
                                    onClick={() => createInvoiceSES()}
                                  >
                                    <i className="bi bi-currency-dollar"></i>{" "}
                                    Create Invoice
                                  </button>
                                </Col>
                              )}
                            </Col>
                          )}
                        </>
                      )}
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Document Number"
                          name="purchasingDocumentNr"
                          placeholder=""
                          value={getHeaderData?.purchasingDocumentNr || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Document Date"
                          name="purchasingDocumentDate"
                          placeholder=""
                          value={
                            formatDate(getHeaderData?.purchasingDocumentDate) ||
                            ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Currency"
                          placeholder=""
                          name="currency"
                          id="currency"
                          value={getHeaderData?.currency || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vendor Code"
                          name="vendorCode"
                          placeholder=""
                          value={getHeaderData?.AssociateNumber || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vendor Name"
                          name="organisationName"
                          placeholder=""
                          value={getHeaderData?.organisationName || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Payment Terms"
                          name="paymentTerms"
                          placeholder=""
                          value={getHeaderData?.paymentTerms || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Code "
                          name="companyCodeCode"
                          id="companyCodeCode"
                          value={getHeaderData?.companyCodeCode}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Purchse Type"
                          name="productType"
                          placeholder=""
                          value={getHeaderData?.productType || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Item Total Amount"
                          placeholder=""
                          name="totalQtnItemValue"
                          id="totalQtnItemValue"
                          value={totalQtnItemValue}
                          disabled={true}
                        // required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tax Amount"
                          placeholder=""
                          name="totalTaxAmount"
                          id="totalTaxAmount"
                          value={totalTaxAmount}
                          // error={validation.truckNo || ""}
                          // onChange={handleInputChange}
                          disabled={true}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Purchase Net Value"
                          placeholder=""
                          name="totalGrossValue"
                          id="totalGrossValue"
                          value={totalGrossValue}
                          // error={validation.truckNo || ""}
                          // onChange={handleInputChange}
                          disabled={true}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding mt-4 pt-3"
                      >
                        <div>
                          <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                            Header Text
                          </label>
                          <span
                            style={{ marginLeft: "15px" }}
                            onClick={() =>
                              headerTextShowModal(getHeaderData?.headerTextData)
                            }
                          >
                            <i className="bi bi-calendar2-week iconTable"></i>
                          </span>
                          <span className="suppliersIcon">
                            {" "}
                            {getHeaderData?.headerTextData?.length || 0}{" "}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Line Itemss */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible2
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LI</span>
                    </Col>
                    <Col xs={12} md={3} lg={3}>
                      <span className="headerTitle">Line Items</span>
                      <span className="subHeaderTitle"> </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {userInfo?.roles?.length > 0 &&
                        (userInfo?.roles[0].roleId === "VENDOR"
                          ? true
                          : false) &&
                        getHeaderData?.statusHeader !== "Acknowledged" && (
                          <>
                            <Col xs={4} md={2} lg={2} className="">
                              <button
                                className="btnTable"
                                onClick={() => handleAcknowledgeClick()}
                                disabled={disabled}
                              >
                                <i className="bi bi-check-circle"></i>{" "}
                                Acknowledge
                              </button>
                            </Col>
                          </>
                        )}

                      <Col xs={2} md={2} lg={2} className="">
                        {getServiceTableStatus ? (
                          <button className="btn btn-danger" onClick={hide}>
                            <i className="bi bi-eye-slash-fill"></i> Hide
                            Serivces
                          </button>
                        ) : (
                          " "
                        )}
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={
                            getHeaderData.purchaseTypeCode === "MAT"
                              ? columns
                              : getHeaderData.purchaseTypeCode === "SER"
                                ? columnsService
                                : getHeaderData.purchaseTypeCode === "SA"
                                  ? columnsSchedule
                                  : columns
                          }
                          data={data}
                          progressPending={loading}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          onSelectedRowsChange={handleChange}
                          clearSelectedRows={toggleCleared}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Itemss */}
            {getServiceTableStatus && (
              <div
                ref={divRef}
                className="accordion mb-4"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">LI</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">
                          {getHeaderData.purchaseTypeCode === "SER"
                            ? `Services - PO Item: ${getItemNr}`
                            : getHeaderData.purchaseTypeCode === "SA"
                              ? `Schedules - SA Item: ${getItemNr}`
                              : ""}
                        </span>
                        <span className="subHeaderTitle"> </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                      }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={
                              getHeaderData.purchaseTypeCode === "SER"
                                ? serviceColInfo
                                : getHeaderData.purchaseTypeCode === "SA"
                                  ? scheduleColInfo
                                  : ""
                            }
                            data={getServiceData}
                            progressPending={loading}
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                            onSelectedRowsChange={handleChange}
                            clearSelectedRows={toggleCleared}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Col>
      </Row>

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* Header Text  */}
      <CommonItemLevelDatatableModal
        show={getViewHeaderText}
        onHide={() => headerTextHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
    </main>
  );
};

export default PurchaseOrderDetailedPage;
